import { render, staticRenderFns } from "./InsuranceStatusChip.vue?vue&type=template&id=74b42a45&scoped=true"
import script from "./InsuranceStatusChip.vue?vue&type=script&lang=js"
export * from "./InsuranceStatusChip.vue?vue&type=script&lang=js"
import style0 from "./InsuranceStatusChip.vue?vue&type=style&index=0&id=74b42a45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b42a45",
  null
  
)

export default component.exports